import styled from "styled-components";

export const Img = styled.img`
display:flex;
margin:0 auto 20px auto;
`;
